module.exports = __webpack_public_path__ + "img/delete-h.98a2c1ad.svg";